import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[cignaIconDynamic]',
})
export class IconDynamicDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
